export var PlaceMent = ['top', 'bottom'];


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-mentions/src/placement.js
// module id = 353
// module chunks = 0